import React from 'react';
import useStyles from './styles';

function ObtionsBaloom({options, open, top}) {
  const classes = useStyles();
  if (open) {
    return (
      <div className={classes.dotsOpts} style={top ? {top: top} : {}}>
        {options && options.map(opt => {
          if (opt.show !== false) {
            return <a onClick={opt.onClick}>{opt.text}</a>
          }
        })}
      </div>
    );
  }
  else {
    return <></>
  }
  
}

ObtionsBaloom.Container = React.forwardRef((props, ref) => {
  return <div ref={ref} style={{position: "relative"}}>{props.children}</div>
})

export default ObtionsBaloom;